import { useSyncExternalStore } from 'react'
import { getNetworkDown, subscribeNetwork } from '@/api/events'

function subscribeBrowser(listener: () => void) {
  window.addEventListener('online', listener)
  window.addEventListener('offline', listener)
  return () => {
    window.removeEventListener('online', listener)
    window.removeEventListener('offline', listener)
  }
}

/** False when the browser is offline or a request recently failed with network_error. */
export function useOnline(): boolean {
  const browserOnline = useSyncExternalStore(subscribeBrowser, () => navigator.onLine, () => true)
  const networkDown = useSyncExternalStore(subscribeNetwork, getNetworkDown, () => false)
  return browserOnline && !networkDown
}
